// ÉLŐ követelmény-lista a jelszó-mező alatt (12 karakter · kisbetű · nagybetű · szám · ≠ jelenlegi).
//
// MIÉRT lista és nem hibaüzenet: jelszó-megadásnál a felhasználónak ÚTMUTATÁS kell, nem kudarc-jelentés —
// előre látja, mit vár a rendszer, és gépelés közben pipálódnak a teljesült pontok. Ez a bevett minta
// (Google/GitHub/Stripe). A hibaüzenet-megfogalmazás („Tartalmazzon nagybetűt is") csak AKKOR helyénvaló, ha
// már elrontotta — itt viszont még be sem fejezte.
//
// HÁROM ÁLLAPOT, szándékosan:
//   pending  — még nem teljesült, de nem is hibáztatjuk (semleges): amíg nem próbált beküldeni
//   met      — teljesült (zöld pipa)
//   failed   — nem teljesült ÉS már próbálta beküldeni (piros) → ilyenkor már jogos a hibáztatás
// Így nem „kiabál" gépelés közben, de a beküldés sosem néma.
//
// A11Y: `<ul>` + per-elem REJTETT állapot-szöveg (a képernyőolvasó a „teljesítve/hiányzik" szót is hallja, nem
// csak a szabályt); a lista `aria-describedby`-jal a jelszó-mezőhöz köthető, és `aria-live="polite"`, hogy a
// pipálódás bemondásra kerüljön anélkül, hogy félbeszakítaná a gépelést.
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

export type RequirementState = 'pending' | 'met' | 'failed';

export interface PasswordRequirement {
  key: string;
  label: string;
  state: RequirementState;
}

export function PasswordRequirements({
  id,
  requirements,
}: {
  id?: string;
  requirements: PasswordRequirement[];
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <ul
      id={id}
      aria-live="polite"
      // NÉGY szabály → `sm`-től KIEGYENSÚLYOZOTT 2×2 rács (nincs árván lógó elem); 375px-en egy oszlop,
      // mert négy elem egy sorban ott úgyis csúnyán tördelne. Egy soros elrendezés szándékosan NINCS.
      className="grid gap-x-6 gap-y-2 sm:grid-cols-2"
      data-testid="password-requirements"
    >
      {requirements.map((r) => (
        <li
          key={r.key}
          data-rule={r.key}
          data-state={r.state}
          className={cn(
            'flex items-center gap-1.5 text-xs',
            r.state === 'met' && 'text-success',
            r.state === 'failed' && 'text-destructive',
            r.state === 'pending' && 'text-muted-foreground',
          )}
        >
          {r.state === 'failed' ? (
            <XCircleIcon className="size-3.5 shrink-0" aria-hidden="true" />
          ) : (
            <CheckCircleIcon
              className={cn('size-3.5 shrink-0', r.state === 'pending' && 'opacity-40')}
              aria-hidden="true"
            />
          )}
          <span>{r.label}</span>
          {/* Az ÁLLAPOT szövegesen is — az ikon önmagában képernyőolvasóval néma. */}
          <span className="sr-only">
            {r.state === 'met' ? t('profile.password.ruleMet') : t('profile.password.ruleMissing')}
          </span>
        </li>
      ))}
    </ul>
  );
}
